import useTranslator from "../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  haveValue,
  isDefaulter,
} from "../../helper/common";
import CloseIcon from "../../assets/img/closeIcon.svg";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useState } from "react";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import DocumentSvg from "../../assets/img/Document.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";

// ─── Single debt block dropdown ───────────────────────────────────────────────
const DebtDetailDropdown = ({ block, index, _t, experianJson }) => {
  const [showDropdown, setShowDropDown] = useState(false);

  const tooltipSuffix = `-${index}`;

  return (
    <div className="detail-debt-info-container">
      <div
        className="detail-debt-info-container-header cursor-pointer"
        onClick={() => setShowDropDown(!showDropdown)}
      >
        <div className="d-flex align-items-center justify-content-between w-100">
          <div>
            <h3 className="detail-debt-title">
              {block?.Informante && block.Informante}
            </h3>
            <h4 className="detail-debt-date">
              <span>{_t("lastDefault")}: </span>
              <span>
                {(() => {
                  const d = block?.FechaUltimoVencimientoImpagado;
                  return `${d?.DD}/${d?.MM}/${d?.AAAA}`;
                })()}
              </span>
            </h4>
          </div>
          <div className="d-flex align-items-center custom-gap-2">
            <div className="detail-debt-info-container-dropdown-info-data-values detail-debt-price-active">
              <span className="active-status active-status-debt">
                {_t(block?.SituacionPago?.TTipoCodigo?.[0]?.Descripcion)}
              </span>
            </div>
            <div className="detail-debt-info-container-dropdown-info-data-values detail-debt-price">
              <span>€{block?.SaldoImpagado}</span>
            </div>

            {showDropdown ? (
              <IoIosArrowUp size={18} style={{ color: "#253837" }} />
            ) : (
              <IoIosArrowDown size={18} style={{ color: "#253837" }} />
            )}
          </div>
        </div>
      </div>

      {showDropdown && (
        <div className="detail-debt-info-container-dropdown">
          {/* Operation Details */}
          <div className="detail-debt-info-container-dropdown-info">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-text h-5 w-5"
              >
                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                <path d="M10 9H8" />
                <path d="M16 13H8" />
                <path d="M16 17H8" />
              </svg>
              <span>{_t("operationDetails")}</span>
              <img
                data-tooltip-id={`operation-details-tooltip${tooltipSuffix}`}
                src={moreInfoimg}
                alt="Vector Icon"
                className="vactorImg vactorImg1 default-check-img"
              />
              <ReactTooltip
                id={`operation-details-tooltip${tooltipSuffix}`}
                noArrow
                className="react-tooltip-styling details-skor-tooltip"
                render={() => (
                  <p>
                    {_t(
                      "itIdentifiesTheLoanBehindTheDebtShowingWhoIssuedItWhatTypeOfCreditItIsAndTheOfficialOperationIdUsedByTheLenderWhenReportingItToTheCreditBureau"
                    )}
                  </p>
                )}
              />
            </div>
            <div className="detail-debt-info-container-dropdown-info-data">
              <div className="detail-debt-info-container-dropdown-info-data-values">
                <h2>{_t("creditor")}</h2>
                <span>{block?.Informante}</span>
              </div>
              <div className="detail-debt-info-container-dropdown-info-data-values">
                <h2>{_t("product")}</h2>
                <span>{block?.TipoProductoFinanciado?.Descripcion}</span>
              </div>
              <div className="detail-debt-info-container-dropdown-info-data-values">
                <h2>{_t("operationId")}</h2>
                <span>{block?.IdOperacion}</span>
              </div>
            </div>
          </div>

          {/* Payment History */}
          <div className="detail-debt-info-container-dropdown-info">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar h-4 w-4"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
              </svg>
              <span>{_t("paymentHistory")}</span>
              <img
                data-tooltip-id={`payment-history-tooltip${tooltipSuffix}`}
                src={moreInfoimg}
                alt="Vector Icon"
                className="vactorImg vactorImg1 default-check-img"
              />
              <ReactTooltip
                id={`payment-history-tooltip${tooltipSuffix}`}
                noArrow
                className="react-tooltip-styling details-skor-tooltip"
                render={() => (
                  <p>
                    {_t(
                      "itSummarisesHowTheDebtHasEvolvedOverTimeWhenTheTenantFirstStoppedPayingHowManyInstallmentsRemainUnpaidHowMuchIsStillOwedAndTheMostRecentStatusReportedByTheLender"
                    )}
                  </p>
                )}
              />
            </div>
            <div className="detail-debt-info-container-dropdown-info-data">
              <div className="d-flex align-items-center justify-content-between">
                <div
                  className="detail-debt-info-container-dropdown-info-data-values"
                  style={{ width: "50%" }}
                >
                  <h2>{_t("firstDefault")}</h2>
                  <span>
                    {(() => {
                      const d = block?.FechaPrimerVencimientoImpagado;
                      return `${d?.DD}/${d?.MM}/${d?.AAAA}`;
                    })()}
                  </span>
                </div>
                <div
                  className="detail-debt-info-container-dropdown-info-data-values"
                  style={{ width: "50%" }}
                >
                  <h2>{_t("lastDefault")}</h2>
                  <span>
                    {(() => {
                      const d = block?.FechaUltimoVencimientoImpagado;
                      return `${d?.DD}/${d?.MM}/${d?.AAAA}`;
                    })()}
                  </span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div
                  style={{ width: "50%" }}
                  className="detail-debt-info-container-dropdown-info-data-values"
                >
                  <h2>{_t("unpaidInstallments")}</h2>
                  <span>{block?.NumeroCuotasImpagadas}</span>
                </div>
                <div
                  style={{ width: "50%" }}
                  className="detail-debt-info-container-dropdown-info-data-values"
                >
                  <h2>{_t("balanceOutstanding")}</h2>
                  <span>€{block?.SaldoImpagado}</span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div
                  style={{ width: "50%" }}
                  className="detail-debt-info-container-dropdown-info-data-values"
                >
                  <h2>{_t("maximumOutstandingAmount")}</h2>
                  <span>€{block?.MaximoImporteImpagado}</span>
                </div>
                <div
                  style={{ width: "50%" }}
                  className="detail-debt-info-container-dropdown-info-data-values"
                >
                  <h2>{_t("debtStatus")}</h2>
                  <span className="active-status">
                    {_t(block?.SituacionPago?.TTipoCodigo?.[0]?.Descripcion)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Status Evolution */}
          <div className="detail-debt-info-container-dropdown-info">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-trending-up h-4 w-4"
              >
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
              <span>{_t("paymentStatusEvolution")}</span>
              <img
                data-tooltip-id={`payment-status-tooltip${tooltipSuffix}`}
                src={moreInfoimg}
                alt="Vector Icon"
                className="vactorImg vactorImg1 default-check-img"
              />
              <ReactTooltip
                id={`payment-status-tooltip${tooltipSuffix}`}
                noArrow
                className="react-tooltip-styling details-skor-tooltip"
                render={() => (
                  <p>
                    {_t(
                      "thisTimelineShowsHowTheDebtProgressedFromEarlyLatePayments60150DaysWhichIndicateSeveralMissedInstallmentsToAJudicialStatusMeaningTheCaseHasEscalatedToFormalLegalAction"
                    )}
                  </p>
                )}
              />
            </div>
            <div className="detail-debt-info-container-dropdown-info-data">
              {[...(block?.SituacionPago?.TTipoCodigo || [])]
                ?.reverse()
                ?.map((val) => {
                  if (["2", "3", "4"].includes(val?.Codigo))
                    return (
                      <div
                        key={val?.Codigo}
                        className="detail-debt-info-container-dropdown-info-data-values-new"
                      >
                        <span>{val?.Codigo}</span>
                        <p>{_t(val?.Descripcion)}</p>
                      </div>
                    );
                })}
              {haveValue(block?.SituacionPago?.TTipoCodigo?.[0]) && (
                <div
                  style={{ width: "100%" }}
                  className="detail-debt-info-container-dropdown-info-data-values-new"
                >
                  <div className="judicial-status">
                    <span>
                      {
                        [...(block?.SituacionPago?.TTipoCodigo || [])]
                          ?.reverse()
                          ?.pop()?.Codigo
                      }
                    </span>
                    <p>
                      {
                        [...(block?.SituacionPago?.TTipoCodigo || [])]
                          ?.reverse()
                          ?.pop()?.Descripcion
                      }
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Registration Details */}
          <div className="detail-debt-info-container-dropdown-info">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-calendar h-4 w-4"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
              </svg>
              <span>{_t("registrationDetails")}</span>
              <img
                data-tooltip-id={`registration-details-tooltip${tooltipSuffix}`}
                src={moreInfoimg}
                alt="Vector Icon"
                className="vactorImg vactorImg1 default-check-img"
              />
              <ReactTooltip
                id={`registration-details-tooltip${tooltipSuffix}`}
                noArrow
                className="react-tooltip-styling details-skor-tooltip"
                render={() => (
                  <p>
                    {_t(
                      "theRegistrationDateShowsWhenTheUnpaidDebtWasFirstreportedToTheCreditBureauAndTheLastUpdateReflectsTheMostRecentInformationProvidedByTheLender"
                    )}
                  </p>
                )}
              />
            </div>
            <div className="detail-debt-info-container-dropdown-info-data">
              <div className="d-flex align-items-center justify-content-between">
                <div
                  style={{ width: "50%" }}
                  className="detail-debt-info-container-dropdown-info-data-values"
                >
                  <h2>{_t("registrationDate")}</h2>
                  <span>
                    {(() => {
                      const d = block?.FechaAlta;
                      return `${d?.DD}/${d?.MM}/${d?.AAAA}`;
                    })()}
                  </span>
                </div>
                <div
                  style={{ width: "50%" }}
                  className="detail-debt-info-container-dropdown-info-data-values"
                >
                  <h2>{_t("lastUpdate")}</h2>
                  <span>
                    {(() => {
                      const d = block?.FechaUltimaActualizacion;
                      return `${d?.DD}/${d?.MM}/${d?.AAAA}`;
                    })()}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Sociodemographic Mark */}
          <div className="detail-debt-info-container-dropdown-info">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-4 w-4"
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>{_t("SociodemographicMark")}</span>
              <img
                data-tooltip-id={`socio-demo-tooltip${tooltipSuffix}`}
                src={moreInfoimg}
                alt="Vector Icon"
                className="vactorImg vactorImg1 default-check-img"
              />
              <ReactTooltip
                id={`socio-demo-tooltip${tooltipSuffix}`}
                noArrow
                className="react-tooltip-styling details-skor-tooltip"
                render={() => (
                  <p>
                    {_t(
                      "thisRatingComesFromNeighborhoodDemographicsNotTheTenantPersonalDataAreasScoredATendToShowLowerAverageRiskWhileFAreasShowHigherRiskThoughThisStillDoesntDescribeTheTenantThemselves"
                    )}
                  </p>
                )}
              />
            </div>
            <div className="detail-debt-info-container-dropdown-info-data">
              <div className="detail-debt-info-container-dropdown-info-data-values-map">
                <span>
                  {
                    experianJson?.["s:Envelope"]?.["s:Body"]
                      ?.GenerarInformeResponse?.GenerarInformeResult
                      ?.InformeDelphi4A3?.InformacionDelphi?.Nota
                  }
                </span>
                <p>
                  ({_t("basedOnPostalCode")} {block?.Direccion?.CodigoPostal})
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Main Modal ───────────────────────────────────────────────────────────────
const DefaultCheckReportModal = ({ isOpen, onClose, user }) => {
  const { _t } = useTranslator();
  const experianJson = user?.tenant_extra_field_id?.experianJson;
  const experianData =
    experianJson?.["s:Envelope"]?.["s:Body"]?.GenerarInformeResponse
      ?.GenerarInformeResult?.InformeDelphi4A3;

  const TBloqueDetalleOperacionRaw =
    experianJson?.badexcugRawData?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDetalleOperaciones
      ?.Registros?.TBloqueDetalleOperacion;

  // Normalise: always work with an array
  const TBloqueDetalleOperacionList = Array.isArray(TBloqueDetalleOperacionRaw)
    ? TBloqueDetalleOperacionRaw
    : TBloqueDetalleOperacionRaw
      ? [TBloqueDetalleOperacionRaw]
      : [];

  // For the summary card at the top, use the first block (worst/most relevant)
  const primaryBlock = TBloqueDetalleOperacionList[0];

  const isUserDefaulter = isDefaulter(experianData);

  const getMaxDelay = () => {
    let maxDays = 0;
    let maxDescripcion = "";

    const toDate = (obj) => {
      if (!obj?.DD || !obj?.MM || !obj?.AAAA) return null;
      return new Date(
        `${obj.AAAA}-${String(obj.MM).padStart(2, "0")}-${String(obj.DD).padStart(2, "0")}`
      );
    };

    TBloqueDetalleOperacionList.forEach((block) => {
      const first = toDate(block?.FechaPrimerVencimientoImpagado);
      const last = toDate(block?.FechaUltimoVencimientoImpagado);

      if (first && last) {
        const days = Math.round((last - first) / (1000 * 60 * 60 * 24));

        if (days > maxDays) {
          maxDays = days;
          maxDescripcion =
            block?.SituacionPago?.TTipoCodigo?.[0]?.Descripcion ?? "";
        }
      }
    });

    return {
      maxDays,
      maxDescripcion,
    };
  };

  const { maxDescripcion } = getMaxDelay();

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal default-check-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="doc-history-header">
          <img
            src={CloseIcon}
            alt=""
            className="doc-history-close-btn"
            onClick={onClose}
          />
          <h4 className="custom-modal-heading">{_t("defaulterCheckReport")}</h4>
        </div>

        {/* ── Summary risk card ── */}
        <div
          className="risk-card"
          style={{
            borderColor: isUserDefaulter ? "#fbc2c2" : "#c1f7d6",
            backgroundColor: isUserDefaulter ? "#fef2f1" : "#edfdf3",
          }}
        >
          <div className="risk-card-top">
            <div className="risk-card-left">
              <div className="risk-card-title">
                {isUserDefaulter ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="lucide lucide-circle-check h-6 w-6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12.0007" r="10.6667" fill="#FF3C3C" />
                    <path
                      d="M12.0006 13.9755C12.2521 13.9755 12.4932 13.8714 12.6711 13.6862C12.8489 13.501 12.9488 13.2497 12.9488 12.9878V7.06187C12.9488 6.79993 12.8489 6.54872 12.6711 6.3635C12.4932 6.17828 12.2521 6.07422 12.0006 6.07422C11.7492 6.07422 11.508 6.17828 11.3302 6.3635C11.1524 6.54872 11.0525 6.79993 11.0525 7.06187V12.9878C11.0525 13.2497 11.1524 13.501 11.3302 13.6862C11.508 13.8714 11.7492 13.9755 12.0006 13.9755ZM12.0006 17.9261C12.235 17.9261 12.4642 17.8537 12.6591 17.718C12.854 17.5824 13.0059 17.3895 13.0956 17.164C13.1853 16.9384 13.2088 16.6901 13.163 16.4507C13.1173 16.2112 13.0044 15.9912 12.8387 15.8185C12.6729 15.6459 12.4617 15.5283 12.2318 15.4807C12.0019 15.433 11.7636 15.4575 11.5471 15.5509C11.3305 15.6444 11.1454 15.8026 11.0152 16.0056C10.8849 16.2086 10.8154 16.4473 10.8154 16.6915C10.8154 17.0189 10.9403 17.3329 11.1626 17.5645C11.3848 17.796 11.6863 17.9261 12.0006 17.9261Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#15a24a"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-circle-check h-6 w-6"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                )}
                <span>{_t("defaultProbability")}</span>
              </div>
              <div
                style={{ color: isUserDefaulter ? "#ef4343" : "#15a24a" }}
                className="risk-card-value"
              >
                {isUserDefaulter
                  ? _t("defaultsDetected")
                  : _t("noDefaultsDetected")}
              </div>
            </div>
          </div>

          {isUserDefaulter && TBloqueDetalleOperacionList.length > 0 && (
            <>
              <div
                style={{ backgroundColor: "#efedf0" }}
                className="risk-card-divider"
              />
              <div className="risk-card-bottom">
                <div>
                  <div className="risk-card-label">{_t("totalDebt")}</div>
                  <div
                    style={{ color: "#0f1729" }}
                    className="risk-card-status"
                  >
                    €
                    {convertCurrencyFormat(
                      TBloqueDetalleOperacionList.reduce((sum, block) => {
                        const val = parseFloat(
                          String(block?.SaldoImpagado ?? "0").replace(",", ".")
                        );
                        return sum + (isNaN(val) ? 0 : val);
                      }, 0).toFixed(2)
                    )}
                  </div>
                </div>
                <div>
                  {maxDescripcion && (
                    <div className="risk-card-label">{_t("longerDelay")}</div>
                  )}

                  <div
                    style={{ color: "#ef4343" }}
                    className="risk-card-status"
                  >
                    {_t(maxDescripcion)}
                  </div>
                </div>
                <div>
                  <div className="risk-card-label">
                    {_t("lastMissedPayment")}
                  </div>
                  <div
                    style={{ color: "#0f1729" }}
                    className="risk-card-status"
                  >
                    {(() => {
                      let latestDate = null;
                      let latestStr = "";
                      TBloqueDetalleOperacionList.forEach((block) => {
                        const obj = block?.FechaUltimoVencimientoImpagado;
                        if (!obj?.DD || !obj?.MM || !obj?.AAAA) return;
                        const d = new Date(
                          `${obj.AAAA}-${String(obj.MM).padStart(2, "0")}-${String(obj.DD).padStart(2, "0")}`
                        );
                        if (!latestDate || d > latestDate) {
                          latestDate = d;
                          latestStr = `${obj.DD}/${obj.MM}/${obj.AAAA}`;
                        }
                      });
                      return latestStr;
                    })()}
                  </div>
                </div>
              </div>
              <div className="risk-card-records">
                {TBloqueDetalleOperacionList.length} {_t("recordsFound")}
              </div>
            </>
          )}
        </div>

        {/* ── Debt detail dropdowns (one per block) ── */}
        {isUserDefaulter ? (
          TBloqueDetalleOperacionList.map((block, index) => (
            <DebtDetailDropdown
              key={block?.IdOperacion ?? index}
              block={block}
              index={index}
              _t={_t}
              experianJson={experianJson}
            />
          ))
        ) : (
          <div className="experian-no-default">
            <img src={DocumentSvg} alt="" />
            <p>{_t("thisUserHasNoDefaultHistory")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DefaultCheckReportModal;
